import { Entry } from '../Entry'

export function Entry20260625() {
  return (
    <Entry title="2026 Jun 25 - v3.11.14">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RO/versions/25905/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
